export default {
    /*
     * 公共路径
     */
    // path: {
    //   // source: "http://cs.bohechina.com:8060/api",
    // //   source: "http://192.168.55.87:8095/api",
    // },
    /*
     *请求设置
     */
    http: {
      // 开发环境
      // baseUrl: "http://192.168.55.77:10088/api",
      // baseUrlIMG: "http://192.168.55.77:10088",
      // // baseUrl: "http://192.168.55.74:5005/api",
      // timeOut: 5000, // 超时时间
      // 生产
      // baseUrl: "https://signalr.xunjiangedu.com:10124/api",
      // baseUrlIMG: "https://signalr.xunjiangedu.com:10124",
      // // baseUrl: "http://192.168.55.74:5005/api",
      // timeOut: 5000, // 超时时间
      // 生产
      baseUrl: "https://lzxqbrzx.com:10010/api",
      baseUrlIMG: "https://lzxqbrzx.com:10010",
      // baseUrl: "http://192.168.55.74:5005/api",
      timeOut: 5000, // 超时时间
    },

    /*
     * 固定值配置
     */
    // 统一日期格式
    dateFormat:{
      momentAjax:'YYYY-MM-DDTHH:mm:ss',
      momentShow:'YYYY-MM-DD HH:mm:ss',
      uiValue:"yyyy-MM-ddTHH:mm:ss",
      uiShow:"yyyy-MM-dd HH:mm:ss",
    },
  };
